import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { crewService } from '@services/crew';
import { Crew } from '@models/crew.model';
import { useTranslation } from '@hooks/useTranslation';

export const CREW_QUERY_KEY = (crewId: string | undefined) => [
  'crew',
  crewId ?? 'unknown',
];

export const useCrew = (crewId: string | undefined) => {
  const tActionMessages = useTranslation('actionMessages');
  return useQuery<Crew | null, Error>({
    queryKey: CREW_QUERY_KEY(crewId),
    enabled: !!crewId,
    queryFn: async () => {
      try {
        if (!crewId) throw new Error('crewId is required');
        const crew = await crewService.getCrewById(crewId);
        return crew || null;
      } catch (error: any) {
        toast.error(tActionMessages.errorFetchingCrew);
        throw error;
      }
    },
  });
};

export default useCrew;
